export const getSelectedOptions = (input: HTMLSelectElement) => {
  const options = Array.from(input.options)
  const selectedOptions = options.filter((option) => !!option.selected)
  return selectedOptions.map((option) => option.value)
}
